<template lang="pug">
data-handler(
  v-model="attributes"
  :method="initData"
  :serialize-data-items="serializeDataItems"
  show-loading
)
  template(v-slot:loading)
    v-skeleton-loader(type="list-item")

  template(v-slot:default="{ init }")
    api-form(
      ref="form"
      v-model="formData"
      :method="save"
      :initial="initial"
      :fields="getFields()"
      :success-callback="(data) => successCallback(data, { init })"
      no-reset
      hide-save-btn
      @update="onUpdate"
      @hook:mounted="$emit('init', { method: $refs.form.save })"
    )
</template>

<script>
// Замена старому UserAttributes.vue

import isEqual from 'lodash/isEqual';
import { DIRECTORY_ID } from '@/modules/UserProfile/components/Profile/Sections/constants.js';
import { PER_PAGE } from '@/constants/pagination';

export default {
  name: 'UserAttributes',
  props: {
    component: {
      type: [Object, String],
      default: 'ev-autocomplete',
    },
    onlyClass: {
      type: Boolean,
      default: false,
    },
    accessDirectories: {
      type: Array,
      default: undefined,
    },
    updateOnChange: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: this.value,
      attributes: {
        directoryList: [],
        userList: [],
      },
    };
  },
  computed: {
    initial() {
      const { attributes } = this;
      return attributes.userList.reduce((acc, i) => {
        const [value] = i.values || [];
        return { ...acc, [i.directory_id]: value };
      }, {});
    },
    extraCatchDirectoriesList() {
      return [DIRECTORY_ID.childrenAge, DIRECTORY_ID.adultAge];
    },
    hasChanges() {
      const { formData, initial } = this;
      return !isEqual(formData, initial);
    },
  },
  watch: {
    value(val) {
      this.formData = val;
    },
    formData(val) {
      this.$emit('input', val);
    },
    hasChanges(val) {
      this.$emit('hasChanges', val);
    },
  },
  methods: {
    async initData() {
      const promises = [this.getDirectoryAttributes(), this.getUserAttributes()];

      const [directoryList, userList] = await Promise.all(promises);

      return new Promise((res) => {
        const data = {
          data: {
            directoryList: directoryList?.data?.data || [],
            userList: userList?.data?.data || [],
          },
          result_code: 'FLSCS',
        };
        const headers = { 'x-pagination-per-page': PER_PAGE.infinity };
        res({ data, headers });
      });
    },
    async getUserAttributes(params) {
      const { $user } = this;
      const payload = {
        params: {
          ...params,
          'search[user_id]': $user.data.id,
        },
      };

      const { response } = await this.$rApi.user.getUserAttributes(payload);
      return response;
    },
    async getDirectoryAttributes(params) {
      const payload = {
        params,
      };

      const { response } = await this.$rApi.directories.getEventMemberAdditionalFields(payload);
      return response;
    },
    async save() {
      const { $user, formData } = this;
      const attributes = Object.entries(formData).map(([key, value]) => ({
        directory_id: key,
        values: [].concat(value || []),
      }));
      const payload = {
        params: {
          user_id: $user.data.id,
          attributes,
        },
      };

      return this.$rApi.user.saveUserAttributes(payload);
    },
    getFields() {
      const { component, attributes, isHiddenField } = this;
      const { userList } = attributes;

      const fields = userList.map((i) => ({
        text: i.directory.name,
        value: `${i.directory_id}`,
        hidden: isHiddenField(i),
        component,
        component_attrs: {
          items: i.directory.variants,
          itemText: 'name',
          itemValue: 'id',
          outlined: true,
          dense: true,
        },
      }));

      const visibleFields = fields.filter((i) => !i.hidden);

      return visibleFields;
    },
    serializeDataItems({ directoryList, userList }) {
      const { accessDirectories } = this;
      const serializedUserList = userList
        .filter((i) => (accessDirectories ? accessDirectories.includes(i.directory_id) : i))
        .map((i) => {
          const directory = directoryList.find((d) => d.id === i.directory_id);
          return { ...i, directory };
        });

      return {
        directoryList,
        userList: serializedUserList,
      };
    },
    isHiddenField({ directory }) {
      const { extraCatchDirectoriesList, onlyClass } = this;

      if (onlyClass) {
        return directory.id === DIRECTORY_ID.childrenClass;
      }

      return extraCatchDirectoriesList.includes(directory.id);
    },
    onUpdate({ action }) {
      if (this.updateOnChange) {
        action();
      }
    },
    successCallback(data, { init }) {
      this.$toast.success('Данные успешно сохранены');
      this.$emit('saved');
      init();
    },
  },
};
</script>
